import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de glucides électronique - Apprenez comment calculer les glucides";
const DESCRIPTION =
  "Calculatrice de glucides électronique - Apprenez comment calculer les glucides en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de glucides électronique r les glucides, calculatrice de glucides électronique r les glucides, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/carbohydrate/";
function CarbohydrateCalculator() {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("");
  const [result, setResult] = useState(null);
  const calculateCarbohydrates = () => {
    const genderFactor = gender === "male" ? 5 : -161;
    const calories = Math.round(
      10 * weight + 6.25 * height - 5 * age + genderFactor
    );
    const activityFactors = {
      sedentary: 1.2,
      lightlyActive: 1.375,
      moderatelyActive: 1.55,
      active: 1.725,
      veryActive: 1.9,
    };
    const tdee = calories * activityFactors[activity];
    const tdee_lose_0_5 = calories * activityFactors[activity] - 500;
    const tdee_lose_1 = calories * activityFactors[activity] - 1000;
    const tdee_gain_0_5 = calories * activityFactors[activity] + 500;
    const tdee_gain_1 = calories * activityFactors[activity] + 1000;
    const carbs40 = Math.round((tdee * 0.4) / 3.75);
    const carbs55 = Math.round((tdee * 0.55) / 3.75);
    const carbs65 = Math.round((tdee * 0.65) / 3.75);
    const carbs75 = Math.round((tdee * 0.75) / 3.75);
    const carbs40Lose0_5 = Math.round((tdee_lose_0_5 * 0.4) / 3.75);
    const carbs55Lose0_5 = Math.round((tdee_lose_0_5 * 0.55) / 3.75);
    const carbs65Lose0_5 = Math.round((tdee_lose_0_5 * 0.65) / 3.75);
    const carbs75Lose0_5 = Math.round((tdee_lose_0_5 * 0.75) / 3.75);
    const carbs40Lose1 = Math.round((tdee_lose_1 * 0.4) / 3.75);
    const carbs55Lose1 = Math.round((tdee_lose_1 * 0.55) / 3.75);
    const carbs65Lose1 = Math.round((tdee_lose_1 * 0.65) / 3.75);
    const carbs75Lose1 = Math.round((tdee_lose_1 * 0.75) / 3.75);
    const carbs40Gain0_5 = Math.round((tdee_gain_0_5 * 0.4) / 3.75);
    const carbs55Gain0_5 = Math.round((tdee_gain_0_5 * 0.55) / 3.75);
    const carbs65Gain0_5 = Math.round((tdee_gain_0_5 * 0.65) / 3.75);
    const carbs75Gain0_5 = Math.round((tdee_gain_0_5 * 0.75) / 3.75);
    const carbs40Gain1 = Math.round((tdee_gain_1 * 0.4) / 3.75);
    const carbs55Gain1 = Math.round((tdee_gain_1 * 0.55) / 3.75);
    const carbs65Gain1 = Math.round((tdee_gain_1 * 0.65) / 3.75);
    const carbs75Gain1 = Math.round((tdee_gain_1 * 0.75) / 3.75);
    return {
      goal: "Maintenir le poids",
      calories: tdee,
      carbs40,
      carbs55,
      carbs65,
      carbs75,
      carbs40Lose0_5,
      carbs55Lose0_5,
      carbs65Lose0_5,
      carbs75Lose0_5,
      carbs40Lose1,
      carbs55Lose1,
      carbs65Lose1,
      carbs75Lose1,
      carbs40Gain0_5,
      carbs55Gain0_5,
      carbs65Gain0_5,
      carbs75Gain0_5,
      carbs40Gain1,
      carbs55Gain1,
      carbs65Gain1,
      carbs75Gain1,
      tdee_lose_0_5,
      tdee_lose_1,
      tdee_gain_0_5,
      tdee_gain_1,
    };
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateCarbohydrates();
    setResult(result);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de glucides vous aide à stabiliser, perdre ou gagner du poids. La calculatrice de glucides est un outil précieux qui aide les individus à déterminer le rapport optimal de glucides qu'ils devraient consommer quotidiennement. Les glucides sont une source importante d'énergie dans le régime alimentaire et jouent un rôle essentiel dans la satisfaction des besoins quotidiens du corps. S'ils sont consommés correctement, les glucides peuvent aider à maintenir les niveaux d'énergie et les performances physiques. La calculatrice de glucides est basée sur de nombreux facteurs tels que l'âge, le sexe, le niveau d'activité physique et les objectifs de santé personnels. En saisissant ces informations, un individu peut obtenir des conseils personnalisés sur la quantité de glucides qu'il devrait inclure dans son régime alimentaire quotidien.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Calcul des glucides dans le corps
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="height" className="form-label ms-2">
                        Taille
                      </label>
                    </b>
                    <input
                      type="number"
                      id="height"
                      value={height}
                      onChange={(e) => setHeight(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="175"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">cm</span>
                    </div>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="weight" className="form-label ms-2">
                        Poids
                      </label>
                    </b>
                    <input
                      type="number"
                      id="weight"
                      value={weight}
                      onChange={(e) => setWeight(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="70"
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">kg</span>
                    </div>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="age" className="form-label ms-2">
                        Âge
                      </label>
                    </b>
                    <input
                      type="number"
                      id="age"
                      value={age}
                      onChange={(e) => setAge(e.target.value)}
                      className="form-control"
                      style={{ width: "90%" }}
                      placeholder="30"
                    />
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="gender" className="form-label ms-2">
                        Sexe
                      </label>
                    </b>
                    <select
                      id="gender"
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="male">Homme</option>
                      <option value="female">Femme</option>
                    </select>
                  </div>
                  <br />
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="activity" className="form-label ms-2">
                        Niveau d'activité
                      </label>
                    </b>
                    <select
                      id="activity"
                      value={activity}
                      onChange={(e) => setActivity(e.target.value)}
                      className="form-select"
                      style={{ width: "90%" }}
                    >
                      <option value="">-- Choisir l'activité --</option>
                      <option value="sedentary">
                        Peu actif : Activité physique très faible ou pas d'exercice
                      </option>
                      <option value="lightlyActive">
                        Modérément actif : Exercice léger ou activité physique 1-3 jours par semaine
                      </option>
                      <option value="moderatelyActive">
                        Activité modérée : Exercice modéré ou activité physique 3-5 jours par semaine
                      </option>
                      <option value="active">
                        Très actif : Exercice intense ou activité physique 6-7 jours par semaine
                      </option>
                      <option value="veryActive">
                        Extrêmement actif : Exercice très intense ou activité physique forte quotidiennement
                      </option>
                    </select>
                  </div>
                  <br />
                  <hr />
                  <button
                    type="submit"
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                  >
                    Calculer
                  </button>
                </form>
              </div>
              <div className="col-12 col-md-7">
                {result && (
                  <table >
                    <thead>
                      <tr>
                        <th >Objectif</th>
                        <th >Calories quotidiennes</th>
                        <th >40%</th>
                        <th >55%</th>
                        <th >65%</th>
                        <th >75%</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Maintenir le poids</td>
                        <td>{result.calories} cal</td>
                        <td>{result.carbs40} g</td>
                        <td>{result.carbs55} g</td>
                        <td>{result.carbs65} g</td>
                        <td>{result.carbs75} g</td>
                      </tr>
                      <tr>
                        <td>Perdre 0,5 kg/semaine</td>
                        <td>{result.tdee_lose_0_5} cal</td>
                        <td>{result.carbs40Lose0_5} g</td>
                        <td>{result.carbs55Lose0_5} g</td>
                        <td>{result.carbs65Lose0_5} g</td>
                        <td>{result.carbs75Lose0_5} g</td>
                      </tr>
                      <tr>
                        <td>Perdre 1 kg/semaine</td>
                        <td>{result.tdee_lose_1} cal</td>
                        <td>{result.carbs40Lose1} g</td>
                        <td>{result.carbs55Lose1} g</td>
                        <td>{result.carbs65Lose1} g</td>
                        <td>{result.carbs75Lose1} g</td>
                      </tr>
                      <tr>
                        <td>Gagner 0,5 kg/semaine</td>
                        <td>{result.tdee_gain_0_5} cal</td>
                        <td>{result.carbs40Gain0_5} g</td>
                        <td>{result.carbs55Gain0_5} g</td>
                        <td>{result.carbs65Gain0_5} g</td>
                        <td>{result.carbs75Gain0_5} g</td>
                      </tr>
                      <tr>
                        <td>Gagner 1 kg/semaine</td>
                        <td>{result.tdee_gain_1} cal</td>
                        <td>{result.carbs40Gain1} g</td>
                        <td>{result.carbs55Gain1} g</td>
                        <td>{result.carbs65Gain1} g</td>
                        <td>{result.carbs75Gain1} g</td>
                      </tr>
                    </tbody>
                  </table>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                Tout ce que vous devez savoir sur les glucides : comment les calculer et leur importance dans votre régime alimentaire
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Tout ce que vous devez savoir sur les glucides : comment les calculer et leur importance dans votre régime alimentaire
                  </h2>
                </u>
                <br />
                <p>
                  Les glucides sont l'un des composants fondamentaux de l'alimentation et jouent un rôle essentiel en fournissant de l'énergie au corps et en maintenant ses fonctions vitales. Dans cet article, nous découvrirons le monde des glucides et apprendrons comment les calculer avec précision et leur importance dans votre régime alimentaire.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Concept des glucides</h2>
                </u>
                <br />
                <p>
                  Les glucides sont des composés chimiques composés de carbone, d'hydrogène et d'oxygène. Les glucides incluent les sucres, l'amidon et les fibres, et se trouvent dans de nombreux aliments tels que le pain, le riz, les fruits et les légumes.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Comment calculer les glucides
                  </h2>
                </u>
                <br />
                <p>
                  Il existe un besoin croissant de connaître la quantité de glucides que vous devez consommer quotidiennement pour atteindre un équilibre sain dans votre régime alimentaire. Vous pouvez calculer les glucides en suivant les informations nutritionnelles sur les emballages et en utilisant une calculatrice de glucides en ligne. La calculatrice de glucides vous aide à déterminer la quantité exacte de glucides que vous devez consommer en fonction de vos besoins individuels, de votre niveau d'activité et de vos objectifs de perte ou de prise de poids.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Importance des glucides dans l'alimentation
                  </h2>
                </u>
                <br />
                <p>
                  Les glucides sont votre principale source d'énergie. Ils fournissent au corps 4 calories par gramme. Contrairement aux graisses et aux protéines, les glucides sont plus facilement digérés et utilisés rapidement comme carburant. Pour cette raison, les glucides sont particulièrement importants si vous faites du sport ou si vous êtes très actif physiquement.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Types de glucides
                  </h2>
                </u>
                <br />
                <p>
                  Il existe deux types principaux de glucides : les glucides simples et les glucides complexes. Les glucides simples, comme le sucre et le miel, sont rapidement digérés et absorbés dans le système sanguin. Les glucides complexes, comme l'amidon et les fibres, prennent plus de temps à digérer et fournissent une énergie plus stable. Pour une alimentation équilibrée, vous devriez consommer principalement des glucides complexes.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Questions fréquemment posées</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Combien de glucides dois-je consommer ?
                </h3>
              </div>
              <div className="info-section-body">
                Il existe plusieurs facteurs qui influencent la quantité de glucides dont nous avons besoin, y compris l'intensité et la durée de l'exercice, mais en général pour un athlète, 60-70% de l'énergie devrait provenir des glucides. Les exercices d'intensité élevée pendant 1-3 heures nécessitent environ 6-10 grammes par kilogramme de poids corporel, par rapport aux exercices d'intensité faible qui ne nécessitent que 3-5 grammes par kilogramme de poids corporel. L'apport en glucides dépend du type, de l'intensité et de la durée de l'exercice. Les entraîneurs et la planification sont très utiles pour vous aider à calculer la quantité de glucides dont vous aurez besoin pendant votre entraînement. L'épuisement des glucides conduira le corps à utiliser ses réserves de graisse et de protéines comme carburant, ce qui peut entraîner une fonte musculaire pour le carburant plutôt que pour les aliments.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Comment les glucides affectent-ils la croissance musculaire ?
                </h3>
              </div>
              <div className="info-section-body">
                Certaines personnes pensent que pour développer les muscles rapidement, il faut sacrifier les glucides pour brûler les graisses en tant que carburant et packer la protéine à la place pour aider à la croissance musculaire. C'est vrai quand les athlètes essaient de se couper pendant une courte période, mais pendant la plupart de l'année, quand vous essayez de construire du muscle et d'élargir la croissance, suivre un régime modéré à riche en glucides est la meilleure approche. Les niveaux d'énergie plus élevés, l'augmentation du soutien musculaire, l'augmentation du taux de récupération et la prévention de la dégradation musculaire sont tous garantis lors de la consommation de glucides. Contrairement aux idées fausses, les glucides peuvent aider à développer vos muscles en les rendant plus forts, et ils devraient certainement être inclus dans votre régime alimentaire.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Que se passe-t-il lorsque vous utilisez tous les glucides ?
                </h3>
              </div>
              <div className="info-section-body">
                Votre performance chute d'abord lorsque vous dépassez ou épuisez tous les glucides, et les mouvements musculaires et la stimulation deviennent plus difficiles, ce qui peut par la suite affecter les performances. Lorsque les réserves de glucides sont épuisées, le corps utilisera les protéines comme source d'énergie, ce qui affectera par la suite sa capacité à acquérir et à soutenir les muscles. La combustion de protéines pour l'énergie peut causer plus de problèmes, car lorsque votre corps essaie de se débarrasser des sous-produits des protéines, les reins doivent travailler plus dur, ce qui cause du stress et peut les endommager. Les glucides aident également à alimenter le cerveau et le système nerveux central, et lorsque vos glucides s'épuisent, cela peut affecter les performances des deux et peut entraîner dans les cas graves plus de problèmes.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Les glucides font-ils grossir ?
                </h3>
              </div>
              <div className="info-section-body">
                Non, les glucides eux-mêmes ne causent pas de prise de poids. Si vous consommez plus de calories que vous n'en dépensez, vous prendrez du poids, peu importe les macronutriments d'où proviennent ces calories. Les glucides contiennent 4 calories par gramme, contre 9 calories par gramme pour les graisses. Si vous consommez des types de glucides appropriés en portions appropriées, ils peuvent réellement aider à maintenir et à atteindre un poids santé.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Quels sont les meilleurs glucides à manger ?
                </h3>
              </div>
              <div className="info-section-body">
                Les glucides complexes sont généralement les meilleurs choix. Ils incluent les fruits, les légumes, les grains entiers, les légumineuses et les pommes de terre. Ces aliments contiennent plus de fibres, de vitamines et de minéraux que les glucides simples raffinés, et ils gardent vous vous sentez rassasié plus longtemps. Ils fournissent également une libération d'énergie plus lente et plus stable, ce qui favorise une meilleure santé générale.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CarbohydrateCalculator;
